export interface StartSignatureRequest {
  FileIds: number[];
  FileType: SignatureFileType;
}

export enum SignatureFileType {
  EmploymentConditionsConfirmation = 'EmploymentConditionsConfirmation',
  WorkerAgreement = 'WorkerAgreement',
  Document = 'Document'
}
